import { useEffect, useState } from 'react';
import mediaQueries from '../../const/mediaQueries';
import debounce from '../../helpers/debounce';
import useMedia from './useMedia';
const useWindowWidth = () => {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const matchedWindowSize = useMedia([
        mediaQueries.lessThanSmall,
        mediaQueries.lessThanMedium,
        mediaQueries.lessThanLarge,
        mediaQueries.lessThanHuge
    ], [
        'isLessThanMobile',
        'isLessThanTablet',
        'isLessThanDesktop',
        'isLessThanXLarge'
    ], 'other');
    useEffect(() => {
        const onResize = debounce(() => setSize({ width: window.innerWidth, height: window.innerHeight }), 300);
        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);
    const windowSize = {
        isLessThanMobile: false,
        isLessThanTablet: false,
        isLessThanDesktop: false,
        isLessThanXLarge: false,
        width: size.width,
        height: size.height
    };
    if (matchedWindowSize === 'isLessThanMobile') {
        windowSize.isLessThanMobile = true;
        windowSize.isLessThanTablet = true;
        windowSize.isLessThanDesktop = true;
        windowSize.isLessThanXLarge = true;
    }
    else if (matchedWindowSize === 'isLessThanTablet') {
        windowSize.isLessThanTablet = true;
        windowSize.isLessThanDesktop = true;
        windowSize.isLessThanXLarge = true;
    }
    else if (matchedWindowSize === 'isLessThanDesktop') {
        windowSize.isLessThanDesktop = true;
        windowSize.isLessThanXLarge = true;
    }
    else if (matchedWindowSize === 'isLessThanXLarge') {
        windowSize.isLessThanXLarge = true;
    }
    return windowSize;
};
export default useWindowWidth;
//# sourceMappingURL=useWindowWidth.js.map